<div class="app-splash-screen" *ngIf="showSplash">
    <div class="d-flex justify-content-center align-items-center lightTheme darkTheme">
        <div>
            <div class="d-flex m-4 justify-content-center align-items-center">
                <img src="assets/myfile/MyFileName-White-Transparent.png" alt="" class=" border-solid notShowNameDark ">
                <img src="assets/myfile/MyFileName-Black-Transparent.png" alt="" class=" border-solid notShowNameLight">
            </div>
            <div class="d-flex m-4 justify-content-center align-items-center">
                <div class="app-loader"></div>
            </div>
        </div>
    </div>
</div>